// ========= Slides ========== //
document.addEventListener('DOMContentLoaded', function () {
var elms = document.getElementsByClassName( 'splide' );

for ( var i = 0; i < elms.length; i++ ) {
  new Splide( elms[ i ] ).mount();
}
})

// ========= Place Holder image ========== //
const images = document.querySelectorAll('.video-placeholder .image-placeholder');
const playButton = document.querySelectorAll('.video-placeholder .play-button');
const iframes = document.querySelectorAll('.video-placeholder iframe');
playButton.forEach((image,index) => {
  image.addEventListener('click', () => {
    playButton[index].style.display = 'none';
    images[index].style.display = 'none';
    iframes[index].style.display = 'block';
  })
}) 

var intervalId = setInterval(function() {
  document.querySelectorAll("a").forEach(function(anchor) {
    let url = anchor.getAttribute("href");
    if (url == "/collections/all/products/qlarivia") {
      anchor.setAttribute("target", "_blank");
    }
  });
}, 100);
var intervalId = setInterval(function() {
  document.querySelectorAll("#search-results a").forEach(function(anchor) {
    let url = anchor.getAttribute("href");
    if (url == "/products/qlarivia?_pos=1&_psq=deu&_ss=e&_v=1.0") {
      anchor.setAttribute("target", "_blank");
    }
  });
}, 100);

(function () {
  function simplifyActiveH2RaspberryCards() {
    document.querySelectorAll('.grid-view-item').forEach(function (card) {
      var titleLink = card.querySelector('.product-grid--title a[href="/products/active-h2-ultra?variant=43949053935773"]');
      if (!titleLink || titleLink.textContent.indexOf('Active H2 ULTRA Molecular Hydrogen Tablets Special') === -1) {
        return;
      }

      var badge = card.querySelector('.active-h2-card-badge');
      if (badge) {
        badge.style.display = 'none';
      }

      var button = card.querySelector('.quick-add-button[href="/products/active-h2-ultra?variant=43949053935773"]');
      if (button) {
        button.textContent = 'View Product';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', simplifyActiveH2RaspberryCards);
  } else {
    simplifyActiveH2RaspberryCards();
  }

  window.setTimeout(simplifyActiveH2RaspberryCards, 500);
})();
